module.exports = __webpack_public_path__ + "static/media/jum.adaf7b74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/jum.png
// module id = 1162
// module chunks = 0